import type { Encoding } from './types'

const BOM = [0xef, 0xbb, 0xbf]

/**
 * Bajty → text s detekcí kódování.
 *
 * České POS systémy běžně exportují ve windows-1250; bez detekce se `Zelený`
 * změní na `Zelen?`. Pořadí: BOM → strict UTF-8 → win-1250. Strict UTF-8 test
 * je spolehlivý (nevalidní sekvence vyhodí), ale ne neomylný — proto jde
 * kódování v UI přepnout ručně.
 */
export function decode(buffer: ArrayBuffer, forced?: Encoding): { text: string; encoding: Encoding } {
    const bytes = new Uint8Array(buffer)

    if (forced) {
        return { text: new TextDecoder(forced).decode(stripBom(bytes)), encoding: forced }
    }

    const hasBom = bytes.length >= 3 && BOM.every((b, i) => bytes[i] === b)
    if (hasBom) {
        return { text: new TextDecoder('utf-8').decode(bytes.subarray(3)), encoding: 'utf-8' }
    }

    try {
        const text = new TextDecoder('utf-8', { fatal: true }).decode(bytes)
        return { text, encoding: 'utf-8' }
    } catch {
        return { text: new TextDecoder('windows-1250').decode(bytes), encoding: 'windows-1250' }
    }
}

function stripBom(bytes: Uint8Array): Uint8Array {
    const hasBom = bytes.length >= 3 && BOM.every((b, i) => bytes[i] === b)
    return hasBom ? bytes.subarray(3) : bytes
}
